import React, { FC } from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';

import { ManualAddress } from 'ia-react-core/~/interfaces/ManualAddress';
import filterPropsByComponent from '../../../utils/components/_filterPropsByComponent';
import Form from '../Form';
import { ManualAddressFormProps } from '.';

const withForm = <
  CustomAddress extends object = ManualAddress,
>(WrappedComponent: FC<ManualAddressFormProps<CustomAddress>>) => (
    hoistNonReactStatics((props) => (
      <Form<CustomAddress>
        {...filterPropsByComponent(props, Form)}
      >
        {(formProps) => (
          <WrappedComponent
            {...props}
            {...formProps}
          />
        )}
      </Form>
    ), WrappedComponent)
  );

export default withForm;
